import * as React from 'react'
import { Col, Modal } from 'antd'
import { Text } from 'web-makeup/dist/design-system/styles/typography'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import { useQuery, useMutation } from '@apollo/react-hooks'
import Calendar from 'react-calendar'
import { format } from 'date-fns'

import { GET_CITIES, GET_COUNTRIES } from '../PurchaseOrderRedesigned/PurchaseOrderRedesigned'
import {
  blackListedCountry,
  topListedCountry,
} from '../BrandDashboard/BrandDashboardSettings/config'
import LogoUpload from '../BrandDashboard/components/LogoUpload/LogoUpload'
import DefaultButton from '../BrandDashboard/components/DefaultButton/DefaultButton'
import { client as apolloClient } from '../ApolloProvider/ApolloProvider'
import MultiSelect from '../BrandDashboard/BrandDashboardSettings/MultiSelect'
import { topLocations } from '../../helpers/top-locations-helper'
import { fullCityName } from '../../helpers/locationNames'
import { timezones as timezonesApi } from '../../helpers/timezones'
import { GET_CURRENT_USER } from '../../queries/GetCurrentUserFull'
import { GET_BRANDS_FOR_PURCHASE } from '../../queries/GetBrandsForPurchase'
import { ALL_TAGS } from '../../queries/AllTags'
import { CHANGE_PASSWORD } from '../../mutations/ChangePassword'
import { UPDATE_USER } from '../../mutations/UpdateUser'
import { Gender as genderTypes } from '../../typings/types'
import { logoutAndRedirect } from '../UserDropDown/UserDropDown'

import {
  Avatar,
  Container,
  Main,
  Sidebar,
  BrandCard,
  Logo,
  Signin,
  WhiteBox,
  BrandInfo,
  LogoWrapper,
  Info,
  StyledRow,
  InputLabel,
  Input,
  ButtonWrapper,
  PasswordSection,
  AddButton,
  StyledSelect,
  MobileAvatar,
  DesktopAvatar,
  AntdGlobalStyles,
  PasswordWrapper,
  MobileLogout,
} from './Profile.style'

const Profile: React.FC = () => {
  const [personalInfo, setPersonalInfo] = React.useState({
    avatar: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    date: '',
    gender: '',
    country: '',
    city: '',
    countryUuid: '',
    cityUuid: '',
  })

  const [otherInfo, setOtherInfo] = React.useState({
    timezone: '',
    locale: '',
    skype: '',
    twitter: '',
    facebook: '',
    linkedin: '',
    alternativeEmail: '',
  })
  const [adminOptions, setAdminOptions] = React.useState({
    salesCampaign: '',
    referrer: '',
    referrerState: '',
    salesChannel: '',
    salesSource: '',
    salesMedium: '',
    salesReferrer: '',
  })
  const [currentPassword, setCurrentPassword] = React.useState('')
  const [newPassword, setNewPassword] = React.useState('')
  const [showCalendar, setShowCalendar] = React.useState(false)
  const [adminTags, setAdminTags] = React.useState<any>([])
  const [passwordModal, setPasswordModal] = React.useState(false)

  const { Option } = StyledSelect

  const { data: userData } = useQuery(GET_CURRENT_USER, {
    client: apolloClient,
    errorPolicy: 'all',
  })

  const { data: userBrands } = useQuery(GET_BRANDS_FOR_PURCHASE, {
    client: apolloClient,
    errorPolicy: 'all',
  })

  const { data: allTags } = useQuery(ALL_TAGS, {
    client: apolloClient,
    errorPolicy: 'all',
  })

  const [
    changePassword,
    { loading: changePasswordLoading, error: changePasswordError },
  ] = useMutation(CHANGE_PASSWORD, {
    client: apolloClient,
  })

  const [updateUser, { loading: updateUserLoading }] = useMutation(UPDATE_USER, {
    client: apolloClient,
  })
  const { data: allCountries } = useQuery(GET_COUNTRIES, {
    client: apolloClient,
    errorPolicy: 'all',
  })
  const { data: citiesData, refetch: refetchCities } = useQuery(GET_CITIES, {
    variables: { countryUuid: personalInfo.countryUuid, pageSize: 5 },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })

  const allUserBrands = userBrands && userBrands.allBrandsForPurchase
  const currentUserData = userData && userData.getCurrentUser
  const {
    uuid: curentUserId,
    avatar,
    firstName,
    lastName,
    email,
    phoneNumber,
    dateOfBirth,
    gender,
    location,
    timezone,
    locale,
    skypeUsername,
    twitterProfile,
    facebookProfile,
    linkedinProfile,
    secondaryEmail,
    referrerId,
    referrerState,
    tags,
    salesChannel,
    salesSource,
    salesMedium,
    salesCampaign,
    salesReferrer,
  } = currentUserData || ''

  const localeValues = [{ name: 'English', value: 'en' }, { name: 'Japanese', value: 'ja' }]
  React.useEffect(
    () => {
      setPersonalInfo({
        ...personalInfo,
        avatar: avatar && decodeURIComponent(avatar.cloudinaryId),
        firstName,
        lastName,
        email,
        phone: phoneNumber,
        date: dateOfBirth,
        gender,
        city: location && location.city,
        country: location && location.country,
        countryUuid:
          location &&
          allCountries &&
          allCountries.allCountries.find(c => c.name === location.country),
      })
      setOtherInfo({
        timezone,
        locale,
        skype: skypeUsername,
        twitter: twitterProfile,
        facebook: facebookProfile,
        linkedin: linkedinProfile,
        alternativeEmail: secondaryEmail,
      })
      setAdminOptions({
        salesCampaign,
        referrer: referrerId,
        referrerState,
        salesChannel,
        salesSource,
        salesMedium,
        salesReferrer,
      })
      tags &&
        setAdminTags(
          tags.map(item => {
            return {
              value: item.id,
              label: item.name,
            }
          })
        )
    },
    [currentUserData]
  )

  const userInfo = (
    <>
      {avatar && <Avatar source={decodeURIComponent(avatar.cloudinaryId)} />}
      <Text as="h1" fontSize="h1" color="black1" fontWeight="black">
        {firstName}
        {` `}
        {lastName}
      </Text>
      <Text as="h2" fontSize="h5" color="dawn">
        Administrator
      </Text>
    </>
  )
  const inputFilled = (e: string) => {
    return e === '' || e === null ? '' : 'filled'
  }
  const curPassInput = React.useRef<HTMLInputElement>(null)
  const newPassInput = React.useRef<HTMLInputElement>(null)

  const toggleInputType = (e: HTMLInputElement) => {
    const type = e.getAttribute('type') === 'password' ? 'text' : 'password'
    e.setAttribute('type', type)
  }

  const personalInfoUpdate = () => {
    updateUser({
      variables: {
        userUuid: curentUserId,
        user: {
          avatar: {
            cloudinaryId: personalInfo.avatar,
            cloudinaryType: 'upload',
          },
          firstName: personalInfo.firstName,
          lastName: personalInfo.lastName,
          email: personalInfo.email,
          phoneNumber: personalInfo.phone,
          dateOfBirth: personalInfo.date,
          gender: personalInfo.gender,
          countryUuid: personalInfo.countryUuid,
          cityUuid: personalInfo.cityUuid,
        },
      },
    })
  }
  const otherInfoUpdate = () => {
    updateUser({
      variables: {
        userUuid: curentUserId,
        user: {
          timezone: otherInfo.timezone,
          locale: otherInfo.locale,
          skypeUsername: otherInfo.skype,
          twitterProfile: otherInfo.twitter,
          facebookProfile: otherInfo.facebook,
          linkedinProfile: otherInfo.linkedin,
          secondaryEmail: otherInfo.alternativeEmail,
        },
      },
    })
  }

  const adminOptionsUpdate = () => {
    updateUser({
      variables: {
        userUuid: curentUserId,
        user: {
          referrerId: adminOptions.referrer,
          referrerState: adminOptions.referrerState,
          tags:
            adminTags &&
            adminTags.map(tag => {
              return tag.label
            }),
          salesChannel: adminOptions.salesChannel,
          salesSource: adminOptions.salesSource,
          salesMedium: adminOptions.salesMedium,
          salesCampaign: adminOptions.salesCampaign,
          salesReferrer: adminOptions.salesReferrer,
        },
      },
    })
  }

  const dateFormatMinusTime = 'DD/MM/YYYY'

  const tagsList =
    allTags &&
    allTags.allTags.map(item => {
      return {
        value: item.id,
        label: item.name,
      }
    })

  const countiesList = allCountries && allCountries.allCountries
  const filteredCountryData =
    countiesList &&
    countiesList.filter(obj => {
      return !blackListedCountry.some(v => obj.name === v)
    })
  filteredCountryData &&
    topListedCountry
      .slice(0)
      .reverse()
      .map(item => topLocations(item, filteredCountryData))

  const newTeamMemberModal = (
    <Modal
      visible={passwordModal}
      onCancel={() => setPasswordModal(false)}
      width="27.5rem"
      footer={null}
      style={{ top: '40%' }}
    >
      <Text as="h3" fontSize="h3" color="black1" fontWeight="black" textAlign="center">
        Change password
      </Text>
      <Text as="p" fontSize="h5" color="black1" textAlign="center">
        Are you sure you want to change your password?
      </Text>
      <DefaultButton
        backgroundColor={colors.gandalf}
        color={colors.black1}
        fontSize="0.875rem"
        padding="0 0.875rem"
        buttonHeight="2rem"
        fontWeight="600"
        onClick={() => setPasswordModal(false)}
      >
        No, keep the old password
      </DefaultButton>
      <DefaultButton
        fontSize="0.875rem"
        padding="0 0.875rem"
        backgroundColor={colors.adaptBlue}
        buttonHeight="2rem"
        fontWeight="600"
        onClick={() => {
          setPasswordModal(false)
          changePassword({
            variables: { user: { currentPassword, password: newPassword } },
          })
        }}
      >
        Yes, update my password
      </DefaultButton>
    </Modal>
  )

  return (
    <>
      <AntdGlobalStyles />
      <Container>
        {newTeamMemberModal}
        <Sidebar>
          <DesktopAvatar>{userInfo}</DesktopAvatar>
          <Text as="h4" fontSize="h4" color="black1" fontWeight="black">
            Brands
          </Text>
          {allUserBrands &&
            allUserBrands.map(item => (
              <BrandCard
                key={item.uuid}
                onClick={() =>
                  window.open(`${window.env.BRAND_BASE_URL}/brand-dashboard/${item.uuid}`, '_blank')
                }
              >
                {item.avatar && <Logo source={decodeURIComponent(item.avatar.cloudinaryId)} />}
                <div>
                  <Text as="h4" fontSize="h4" color="black1" fontWeight="bold">
                    {item.tradingName}
                  </Text>
                  <Text as="h4" fontSize="h6" color="dawn" fontWeight="bold">
                    Administrator
                  </Text>
                </div>
                <CloudinaryImage
                  source={{
                    id: 'v1669132317/-design-system/blue-arrow-right.svg',
                    type: 'upload',
                  }}
                />
              </BrandCard>
            ))}
          <AddButton
            onClick={() =>
              allUserBrands[0] &&
              window.open(
                `${window.env.GEN1_BASE_URL}/organisations/${
                  allUserBrands[0].id
                }/subbrands/add?relationship=location`,
                '_blank'
              )
            }
          >
            <CloudinaryImage
              useSourceFormat
              source={{
                id: 'v1609821297/-design-system/icon-add-more-blue.svg',
                type: 'upload',
              }}
            />
          </AddButton>
          <Signin>
            <p>I want to merge my account</p>
            <button onClick={() => logoutAndRedirect('')}>Logout</button>
            <MobileLogout onClick={() => logoutAndRedirect('')}>
              <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1669132104/-design-system/log-out-icon.svg" />
              Log out
            </MobileLogout>
          </Signin>
        </Sidebar>
        <Main>
          <Text as="h2" fontSize="h1" color="black1" fontWeight="bold">
            Personal information
          </Text>
          <WhiteBox>
            <BrandInfo>
              {avatar && <LogoWrapper source={personalInfo.avatar} />}
              <Info>
                <h3>Your profile photo</h3>
                <p>
                  Your profile picture is an important element of your 90 Seconds presence. We
                  recommend you to upload a recent photo of your face.
                </p>
                <LogoUpload
                  onSuccess={e => e && e.url && setPersonalInfo({ ...personalInfo, avatar: e.url })}
                />
              </Info>
            </BrandInfo>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>First name</InputLabel>
                <Input
                  className={inputFilled(personalInfo.firstName)}
                  type="text"
                  placeholder="First name"
                  name="first-name"
                  onChange={e => setPersonalInfo({ ...personalInfo, firstName: e.target.value })}
                  value={personalInfo.firstName}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Last name</InputLabel>
                <Input
                  className={inputFilled(personalInfo.lastName)}
                  type="text"
                  placeholder="Last name"
                  name="last-name"
                  onChange={e => setPersonalInfo({ ...personalInfo, lastName: e.target.value })}
                  value={personalInfo.lastName}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Email</InputLabel>
                <Input
                  className={inputFilled(personalInfo.email)}
                  type="email"
                  placeholder="Email"
                  name="email"
                  onChange={e => setPersonalInfo({ ...personalInfo, email: e.target.value })}
                  value={personalInfo.email}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Phone number</InputLabel>
                <Input
                  className={inputFilled(personalInfo.phone)}
                  type="text"
                  placeholder="Phone number"
                  name="phone-number"
                  onChange={e => setPersonalInfo({ ...personalInfo, phone: e.target.value })}
                  value={personalInfo.phone}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Date of birth</InputLabel>
                <Calendar
                  onChange={value => {
                    setPersonalInfo({ ...personalInfo, date: value })
                    setShowCalendar(false)
                  }}
                  maxDate={new Date()}
                  className={showCalendar ? '' : 'hide'}
                />
                <Input
                  className={inputFilled(personalInfo.date)}
                  readOnly
                  type="text"
                  placeholder="DD/MM/YYYY"
                  name="birth"
                  value={
                    personalInfo.date
                      ? format(new Date(personalInfo.date), dateFormatMinusTime)
                      : undefined
                  }
                  onFocus={() => setShowCalendar(!showCalendar)}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Gender</InputLabel>
                <StyledSelect
                  className={inputFilled(personalInfo.gender)}
                  name="gender"
                  value={personalInfo.gender}
                  suffixIcon={
                    <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                  }
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={value => setPersonalInfo({ ...personalInfo, gender: value })}
                >
                  {(Object.keys(genderTypes) as Array<keyof typeof genderTypes>).map(val => (
                    <Option key={val} value={val} style={{ textTransform: 'capitalize' }}>
                      {val.toLowerCase()}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
            </StyledRow>

            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Country</InputLabel>
                <StyledSelect
                  className={personalInfo.country === '' ? '' : 'filled'}
                  name="country"
                  onChange={value => {
                    setPersonalInfo({
                      ...personalInfo,
                      countryUuid: value.uuid,
                      country: value.name,
                      cityUuid: '',
                      city: '',
                    })
                    refetchCities({
                      countryUuid: value,
                      pageSize: 5,
                    })
                  }}
                  value={personalInfo.country}
                  showSearch
                  suffixIcon={
                    <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                  }
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {filteredCountryData &&
                    filteredCountryData.map(country => (
                      <Option value={country}>{country.name}</Option>
                    ))}
                </StyledSelect>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>City</InputLabel>
                <StyledSelect
                  className={personalInfo.city === '' ? '' : 'filled'}
                  name="city"
                  onChange={value => {
                    setPersonalInfo({ ...personalInfo, cityUuid: value.uuid, city: value.name })
                  }}
                  value={personalInfo.city}
                  showSearch
                  suffixIcon={
                    <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                  }
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {citiesData &&
                    citiesData.findCity &&
                    citiesData.findCity.cities &&
                    citiesData.findCity.cities.map(city => (
                      <Option value={city}>{fullCityName(city.name, city.subdivision1Name)}</Option>
                    ))}
                </StyledSelect>
              </Col>
            </StyledRow>

            <ButtonWrapper>
              <DefaultButton
                fontSize="1rem"
                padding="0 1.625rem"
                backgroundColor={colors.adaptBlue}
                style={{ marginLeft: 'auto' }}
                type="submit"
                onClick={() => personalInfoUpdate()}
              >
                {updateUserLoading ? 'Loading...' : 'Save changes'}
              </DefaultButton>
            </ButtonWrapper>
            <PasswordSection>
              <Text as="h3" fontSize="h2" color="black1" fontWeight="black">
                Change your password
              </Text>
              <Margin bottom size="small" />
              <StyledRow type="flex" gutter={24}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <InputLabel>Enter current password</InputLabel>
                  <PasswordWrapper>
                    <Input
                      type="password"
                      placeholder="Enter your password"
                      name="current-password"
                      className={inputFilled(currentPassword)}
                      onChange={e => setCurrentPassword(e.target.value)}
                      value={currentPassword}
                      ref={curPassInput}
                    />
                    {changePasswordError && <span>Wrong password</span>}
                    <img
                      src="https://res.cloudinary.com/ninety-seconds/image/upload/v1609821794/-design-system/icon-show-password.svg"
                      alt="show password"
                      onClick={() => {
                        curPassInput.current && toggleInputType(curPassInput.current)
                      }}
                    />
                  </PasswordWrapper>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <InputLabel>Enter new password</InputLabel>
                  <PasswordWrapper>
                    <Input
                      type="password"
                      placeholder="Enter new password"
                      name="new-password"
                      className={inputFilled(newPassword)}
                      onChange={e => setNewPassword(e.target.value)}
                      value={newPassword}
                      ref={newPassInput}
                    />
                    <img
                      src="https://res.cloudinary.com/ninety-seconds/image/upload/v1609821794/-design-system/icon-show-password.svg"
                      alt="show password"
                      onClick={() => {
                        newPassInput.current && toggleInputType(newPassInput.current)
                      }}
                    />
                  </PasswordWrapper>
                </Col>
              </StyledRow>
              <ButtonWrapper>
                <DefaultButton
                  fontSize="1rem"
                  padding="0 1.625rem"
                  backgroundColor={colors.adaptBlue}
                  style={{ marginLeft: 'auto' }}
                  type="submit"
                  onClick={() => {
                    setPasswordModal(true)
                  }}
                >
                  {changePasswordLoading ? 'Loading...' : 'Update password'}
                </DefaultButton>
              </ButtonWrapper>
            </PasswordSection>
          </WhiteBox>
          <Text as="h2" fontSize="h1" color="black1" fontWeight="bold">
            Other information
          </Text>
          <WhiteBox>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Timezone</InputLabel>
                <StyledSelect
                  className={inputFilled(otherInfo.timezone)}
                  name="timezone"
                  value={otherInfo.timezone}
                  suffixIcon={
                    <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                  }
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={value => setOtherInfo({ ...otherInfo, timezone: value })}
                >
                  {timezonesApi.map((val, index) => (
                    <Option key={index} value={val.utc[0]}>
                      {val.text}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Locale</InputLabel>
                <StyledSelect
                  className={inputFilled(otherInfo.timezone)}
                  name="locale"
                  value={otherInfo.locale}
                  suffixIcon={
                    <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                  }
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={value => setOtherInfo({ ...otherInfo, locale: value })}
                >
                  {localeValues.map(val => (
                    <Option key={val.value} value={val.value}>
                      {val.name}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Skype</InputLabel>
                <Input
                  type="text"
                  placeholder="Skype"
                  name="skype"
                  className={inputFilled(otherInfo.skype)}
                  onChange={e => setOtherInfo({ ...otherInfo, skype: e.target.value })}
                  value={otherInfo.skype}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Twitter</InputLabel>
                <Input
                  type="text"
                  placeholder="Twitter"
                  name="twitter"
                  className={inputFilled(otherInfo.twitter)}
                  onChange={e => setOtherInfo({ ...otherInfo, twitter: e.target.value })}
                  value={otherInfo.twitter}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Facebook</InputLabel>
                <Input
                  type="text"
                  placeholder="Facebook"
                  name="facebook"
                  className={inputFilled(otherInfo.facebook)}
                  onChange={e => setOtherInfo({ ...otherInfo, facebook: e.target.value })}
                  value={otherInfo.facebook}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>LinkedIn</InputLabel>
                <Input
                  type="text"
                  placeholder="LinkedIn"
                  name="linkedin"
                  className={inputFilled(otherInfo.linkedin)}
                  onChange={e => setOtherInfo({ ...otherInfo, linkedin: e.target.value })}
                  value={otherInfo.linkedin}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Alternative email</InputLabel>
                <Input
                  type="text"
                  placeholder="Alternative email"
                  name="alternativeEmail"
                  className={inputFilled(otherInfo.alternativeEmail)}
                  onChange={e => setOtherInfo({ ...otherInfo, alternativeEmail: e.target.value })}
                  value={otherInfo.alternativeEmail}
                />
              </Col>
            </StyledRow>
            <ButtonWrapper>
              <DefaultButton
                fontSize="1rem"
                padding="0 1.625rem"
                backgroundColor={colors.adaptBlue}
                style={{ marginLeft: 'auto' }}
                type="submit"
                onClick={() => otherInfoUpdate()}
              >
                {updateUserLoading ? 'Loading...' : 'Save changes'}
              </DefaultButton>
            </ButtonWrapper>
          </WhiteBox>
          <Text as="h2" fontSize="h1" color="black1" fontWeight="bold">
            Admin options
          </Text>
          <WhiteBox>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Referrer</InputLabel>
                <Input
                  type="text"
                  placeholder="Referrer"
                  name="referrer"
                  className={inputFilled(adminOptions.referrer)}
                  onChange={e => setAdminOptions({ ...adminOptions, referrer: e.target.value })}
                  value={adminOptions.referrer}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Referrer state</InputLabel>
                <Input
                  type="text"
                  placeholder="Pick a referrer state"
                  name="referrer-state"
                  className={inputFilled(adminOptions.referrerState)}
                  onChange={e =>
                    setAdminOptions({ ...adminOptions, referrerState: e.target.value })
                  }
                  value={adminOptions.referrerState}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputLabel>Tags</InputLabel>
                <MultiSelect
                  options={tagsList}
                  selectValue={adminTags as any}
                  name="functions"
                  placeholder={'Pick a new function'}
                  onChange={value => setAdminTags(value)}
                />
              </Col>
            </StyledRow>
            <Text as="h3" fontSize="h2" color="black1" fontWeight="black">
              Sales tracking
            </Text>
            <Margin bottom size="xSmall" />
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Sales channel</InputLabel>
                <Input
                  type="text"
                  placeholder="Sales channel"
                  name="sales-channel"
                  className={inputFilled(adminOptions.salesChannel)}
                  onChange={e => setAdminOptions({ ...adminOptions, salesChannel: e.target.value })}
                  value={adminOptions.salesChannel}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Sales source</InputLabel>
                <Input
                  type="text"
                  placeholder="Sales source"
                  name="sales-source"
                  className={inputFilled(adminOptions.salesSource)}
                  onChange={e => setAdminOptions({ ...adminOptions, salesSource: e.target.value })}
                  value={adminOptions.salesSource}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Sales medium</InputLabel>
                <Input
                  type="text"
                  placeholder="Sales medium"
                  name="Sales medium"
                  className={inputFilled(adminOptions.salesMedium)}
                  onChange={e => setAdminOptions({ ...adminOptions, salesMedium: e.target.value })}
                  value={adminOptions.salesMedium}
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Sales campaign</InputLabel>
                <Input
                  type="text"
                  placeholder="Sales campaign"
                  name="alternative-email"
                  className={inputFilled(adminOptions.salesCampaign)}
                  onChange={e =>
                    setAdminOptions({ ...adminOptions, salesCampaign: e.target.value })
                  }
                  value={adminOptions.salesCampaign}
                />
              </Col>
            </StyledRow>
            <StyledRow type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputLabel>Sales referrer</InputLabel>
                <Input
                  type="text"
                  placeholder="Add a new sales referrer"
                  name="salesReferrer"
                  className={inputFilled(adminOptions.salesReferrer)}
                  onChange={e =>
                    setAdminOptions({ ...adminOptions, salesReferrer: e.target.value })
                  }
                  value={adminOptions.salesReferrer}
                />
              </Col>
            </StyledRow>
            <ButtonWrapper>
              <DefaultButton
                fontSize="1rem"
                padding="0 1.625rem"
                backgroundColor={colors.adaptBlue}
                style={{ marginLeft: 'auto' }}
                type="submit"
                onClick={() => adminOptionsUpdate()}
              >
                {updateUserLoading ? 'Loading...' : 'Save changes'}
              </DefaultButton>
            </ButtonWrapper>
          </WhiteBox>
        </Main>
        <MobileAvatar>{userInfo}</MobileAvatar>
      </Container>
    </>
  )
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.tsx